import { createReducer } from "redux-create-reducer";

import { CREATE_WATCH_LIST_ENTRY_EU_TERRORISTS } from "../types";

const initialState = {
  isLoading: false,
};

const createWatchListEntryEuTerroristReducer = createReducer(initialState, {
  [CREATE_WATCH_LIST_ENTRY_EU_TERRORISTS.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [CREATE_WATCH_LIST_ENTRY_EU_TERRORISTS.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [CREATE_WATCH_LIST_ENTRY_EU_TERRORISTS.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [CREATE_WATCH_LIST_ENTRY_EU_TERRORISTS.FULFILLED]: (state) => ({
    ...state,
    isLoading: false,
  }),
});

export default createWatchListEntryEuTerroristReducer;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/reducers/createWatchListEntryEuTerroristReducer.js